/* eslint-disable no-nested-ternary */
import React from "react";
import { Text } from "@networkraildigitalfactory/components";

const OneToOneInfo = (props) => {
  const { label, wrapper, isList } = props;
  let { answer } = props;
  if (typeof answer === "string" && answer.includes("\n")) {
    answer = answer.split("\n");
  }

  const ListAnswer = () => (
    <ul style={{ paddingLeft: 20 }}>
      {answer &&
        answer.map((objective) => {
          return (
            <li key={objective.name}>
              <Text wrapper={wrapper || "p"} type="body" style={{ marginBottom: "1em" }}>
                {objective.name}
              </Text>
            </li>
          );
        })}
    </ul>
  );

  const TextAnswer = () => {
    if (typeof answer === "string") {
      return (
        <Text wrapper={wrapper || "p"} type="body" style={{ marginBottom: "1em" }}>
          {answer}
        </Text>
      );
    }

    return answer?.map((line, index) => (
      <Text key={index} wrapper={wrapper || "p"} type="body" style={{ marginBottom: "1em" }}>
        {line}
      </Text>
    ));
  };

  return (
    <>
      <Text wrapper="span" type="body" color="#000000">
        {label}
      </Text>
      {isList ? ListAnswer() : TextAnswer()}
    </>
  );
};
export default OneToOneInfo;
